export enum DelegationStatus {
  WAITING_ACCOUNT_CREATION = "WAITING_ACCOUNT_CREATION",
  WAITING_ACCEPTATION = "WAITING_ACCEPTATION",
  REFUSED = "REFUSED",
  ACCEPTED = "ACCEPTED",
}
